module.exports = __webpack_public_path__ + "img/crash.5a65ebbd.svg";